import { useQuery } from '@tanstack/react-query';

type UseEagerQueryOptions = {
  staleTime?: number;
  refetchOnMount?: boolean | 'always';
  refetchOnWindowFocus?: boolean;
};

export const useEagerQuery = <T>(
  queryKey: readonly unknown[],
  queryFn: () => Promise<T>,
  options?: UseEagerQueryOptions
) => {
  useQuery<T>({
    queryKey,
    queryFn,
    ...(options ?? {}),
  });
};
